<template>
  <div>
    <el-row>
      <el-button type="primary" @click="exportExl" :loading="loading">导出学员详细信息</el-button>
    </el-row>
  </div>
</template>


<script>
import { exportApi } from "@/api/module/export/export"

export default {

  name : 'ExportUserTotalBtn',

  data(){
    return {
      sdate : "",
      edate : "",
      retired : false,
      fresh : false,
      loading : false,
      jsondata : null,
      retired : false,
      df: "yyyy-MM-dd"

    }
  },
  methods:{
    init(){
    },

    setData(sdate,edate,retired,fresh){
      this.sdate = sdate;
      this.edate = edate;
      this.retired = retired;
      this.fresh = fresh;

    },

    exportExl(){
      this.loading = true;

      let serverUrl = "/api/manager/export/users";


      let data = {
        "sdate":this.sdate,
        "edate":this.edate,
        "retired": this.retired,
        "fresh":this.fresh
      }


      let filename = "党校微课堂学员详情数据.xls";
      

      // 暂未提供
      // this.$message.info("功能即将上线");
      // this.loading = false;

      exportApi(data,serverUrl)
          .then((res)=>{
            let data = res.data;
            let url = window.URL.createObjectURL(new Blob([data]));
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click()          
          })
          .catch((e)=>{
            this.$message.error("服务器内部错误!")          
          })
          .finally(()=>{
            this.loading = false;
          })
          ;
    }
  },

  mounted(){

  },

  created() {

  }



}
</script>











<style scoped>
.title {
  font-size: 14px;
  color: #303133;
  display: inline-block;
  padding-left: 10px;
  margin-right: 10px;
}
</style>